<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="LeaveDualPoliciesFilterForm" (ngSubmit)="FilterValidate(LeaveDualPoliciesFilterForm)"
        #LeaveDualPoliciesFilterForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Leave Dual Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center" style="width: 7rem;">
                            <label for="BranchID" class="form-label text-label-dark">Branch: </label>
                        </div>
                        <div class="col-md-5">
                            <ng-select name="BranchID" placeholder="Select Branch" [(ngModel)]="Filter.BranchId"
                                (change)="ComboLoad('Client')" [selectOnTab]="true" [items]="Branchs"
                                bindLabel="BranchName" bindValue="BranchMasterID" [disabled]="IsReset" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select branch!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center" style="width: 7rem;">
                            <label for="ClientID" class="form-label text-label-dark">Client: </label>
                        </div>
                        <div class="col-md-5">
                            <ng-select name="ClientID" placeholder="Select Client" [(ngModel)]="Filter.ClientId"
                                (change)="ComboLoad('Site')" [selectOnTab]="true" [items]="Clients"
                                bindLabel="ClientGroupName" bindValue="ClientGroupMasterID" [disabled]="IsReset"
                                required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select client!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center" style="width: 7rem;">
                            <label for="SiteID" class="form-label text-label-dark">Site: </label>
                        </div>
                        <div class="col-md-5">
                            <ng-select name="SiteID" placeholder="Select Site" [(ngModel)]="Filter.SiteId"
                                [selectOnTab]="true" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                                [disabled]="IsReset" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select Site!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="row mb-3">
                            <div class="col-md-auto align-self-center" style="width: 7rem;">
                                <label for="LeaveMasterID" class="form-label text-label-dark">Leave: </label>
                            </div>
                            <div class="col-md-5">
                                <ng-select name="LeaveMasterID" placeholder="Select Leave Type"
                                    [(ngModel)]="Filter.LeaveMasterId" [items]="LeaveTypes" [selectOnTab]="true"
                                    bindLabel="LeaveName" bindValue="LeaveMasterID" [disabled]="IsReset" required>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select leave type!
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="Applicability" class="form-label text-label-dark">Applicability :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                @for (Applicability of Applicabilitys;track
                                Applicability.WebESSApplicabilityMasterID;let i = $index) {
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID name="Applicability"
                                        [(ngModel)]="Filter.WebESSApplicabilityId" [ngModelOptions]="{standalone: true}"
                                        [disabled]="IsReset">
                                    {{Applicability.ApplicabilityName}}
                                </label>
                                }

                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col"></div>
                        <div class="col-md-auto">
                            <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                                *ngIf="!this.IsReset"><i class="bi bi-arrow-clockwise" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Load':'Loading...'}}</button>

                            <button type="button" class="btn btn-outline-danger" [disabled]="isDisabled"
                                (click)="Clear()" *ngIf="this.IsReset"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Reset':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1" *ngIf="this.IsReset">
                <form class="g-3" name="LeaveDualPoliciesForm" (ngSubmit)="Validate(LeaveDualPoliciesForm)"
                    #LeaveDualPoliciesForm="ngForm" novalidate>
                    <div class="card-header">
                        <div class="row">
                            <div class="col">{{GetApplicabilityName()}}</div>
                            <div class="col-md-3" *ngIf="this.Filter.WebESSApplicabilityId == 6">
                                <ng-select name="DesignationID" placeholder="Add Designation"
                                    [(ngModel)]="Filter.DesignationID" [items]="Designations" [selectOnTab]="true"
                                    bindLabel="DesignationName" bindValue="DesignationMasterID">
                                </ng-select>
                            </div>
                            <div class="col-auto" *ngIf="this.Filter.WebESSApplicabilityId == 6">
                                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                    (click)="AddDesignation()"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                        *ngIf="isDisabled"></span>
                                    {{!isDisabled?'Add':'Loading...'}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-1">
                        <div class="row my-3">
                            <div class="col">

                            </div>
                            <div class="col-auto">
                                <input type="number" class="form-control" id="input-AllDays" name="input-AllDays"
                                    min="0" max="99" step="1" [(ngModel)]="AllDays" style="width: 9rem;font-size: small;">
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="isDisabled"
                                    (click)="ApplyAllDays()"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                        *ngIf="isDisabled"></span>
                                    {{!isDisabled?'All Days':'Loading...'}}</button>
                            </div>
                        </div>

                        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                            class="customeDatatable table table-bordered data-grid">
                            <thead class="table-light">
                                <tr>
                                    <th scope="col" style="width: 5px;">#</th>
                                    <th>Branch Name</th>
                                    <th>Client Name</th>
                                    <th>Site Name</th>
                                    <th style="width: 100px;"
                                        [ngClass]="{'colHide': !(this.Filter.WebESSApplicabilityId == 9) }">Grade</th>
                                    <th style="width: 120px;"
                                        [ngClass]="{'colHide': !(this.Filter.WebESSApplicabilityId == 6) }">Designation
                                    </th>
                                    <th style="width: 125px;">Days</th>
                                    <th style="width: 5px;" [ngClass]="{'colHide': !(this.common.PageRight.IsDelete) }">
                                        Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let Data of DataTable; let i = index">
                                    <th scope="row" style="width: 5px;">{{i+1}}</th>
                                    <td>{{Data['BranchName']}}</td>
                                    <td>{{Data['ClientGroupName']}}</td>
                                    <td>{{Data['SiteCode']}} - {{Data['SiteName']}}</td>
                                    <td style="width: 100px;"
                                        [ngClass]="{'colHide': !(this.Filter.WebESSApplicabilityId == 9) }">
                                        {{Data['GradeName']}}</td>
                                    <td style="width: 120px;"
                                        [ngClass]="{'colHide': !(this.Filter.WebESSApplicabilityId == 6) }">
                                        {{Data['DesignationName']}}</td>
                                    <td style="width: 125px;">
                                        <input type="number" class="form-control" [id]="'input-' + i"
                                            [name]="'input-' + i" min="0" max="99" step="1"
                                            [(ngModel)]="Data['LeaveCredit']" style="font-size: small">
                                    </td>
                                    <td style="width: 5px;align-content: center;text-align: -webkit-center;"
                                        [ngClass]="{'colHide': !(this.common.PageRight.IsDelete) }">
                                        <i class="bi bi-trash deleteIcon" (click)="Delete(i)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-chevron-left" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Back':'Loading...'}}</button>
                            <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                                *ngIf="this.common.PageRight.IsAdd"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Save':'Loading...'}}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </form>
</div>